import { observer } from 'mobx-react-lite'
import { Box, Checkbox, Divider, Icon, Radio, Scrollbar, Tooltip, Typography } from 'shared/ui'
import { roleLabelsMap } from 'entities/Users/lib/rolesConfig'
import { RolesPermissionsHeader } from 'pages/settings/pages/rolesPermissions/ui/RolesPermissionsHeader/RolesPermissionsHeader'
import { useRolesPermissionsContext } from 'pages/settings/pages/rolesPermissions/context/rolesPermissionsContextContext'
import { RolesPermissionsAction } from 'pages/settings/pages/rolesPermissions/ui/RolesPermissionsAction/RolesPermissionsAction'
import styles from './styles.module.scss'

export const RolesPermissionsUi = observer(() => {
  const store = useRolesPermissionsContext()
  const {
    loading,
    roles,
    permissionsRolesOptions,
    isOptionChecked,
    isOptionDisabled,
    optionHandler,
    isOptionRadioChecked,
    optionRadioHandler,
  } = store

  return (
    <Box display={'flex'} flexDirection={'column'} flexGrow={'1'}>
      <RolesPermissionsHeader />

      <Box display={'flex'} flexDirection={'column'} flexGrow={'1'} marginRight={'-20px'}>
        <Scrollbar>
          <div className={styles.container}>
            {permissionsRolesOptions.map((item) => (
              <div key={item.key} className={styles.permissionsWrap}>
                <Box display={'flex'} padding={'20px 0 28px'}>
                  <Typography
                    ariaLabel={item.label}
                    variant={'body-lg-medium'}
                    color={'var(--content-primary-primary)'}
                  >
                    {item.label}
                  </Typography>
                  <div className={styles.blockHeaderRoles}>
                    {roles.map((role) => (
                      <Typography
                        key={role}
                        ariaLabel={roleLabelsMap[role]}
                        variant={'body-md-regular'}
                        className={styles.roleNamesItem}
                      >
                        {roleLabelsMap[role]}
                      </Typography>
                    ))}
                  </div>
                </Box>

                <div className={styles.permissions}>
                  {item.permissions.map((permission, idx) => (
                    <div key={`${permission.key}-${idx}`} className={styles.permission}>
                      <Divider
                        style={{
                          borderColor: 'var(--border-neutral-default)',
                        }}
                      />
                      <div className={styles.permissionContent}>
                        <Typography
                          ariaLabel={permission.label}
                          variant={'body-md-regular'}
                          color={'var(--content-primary-primary)'}
                        >
                          {permission.label}

                          {permission.tooltip && (
                            <Tooltip
                              placement={'top'}
                              label={permission.tooltip.label}
                              className={styles.permissionTooltip}
                              {...(permission.tooltip?.tooltipProps
                                ? permission.tooltip.tooltipProps
                                : {})}
                            >
                              <Icon
                                icon={'question'}
                                color={'var(--content-neutral-primary)'}
                                fontSize={14}
                              />
                            </Tooltip>
                          )}
                        </Typography>
                        <div className={styles.blockHeaderRoles}>
                          {roles.map((role) => (
                            <div className={styles.roleInputs} key={permission.key + role}>
                              {permission.type === 'checkbox' && (
                                <Checkbox
                                  id={permission.key + role + 'checkbox'}
                                  checked={isOptionChecked(permission.key, role)}
                                  disabled={loading || isOptionDisabled(permission.key, role)}
                                  onChange={() => optionHandler(permission.key, role)}
                                  size={20}
                                  style={{ cursor: 'pointer' }}
                                  tooltipProps={
                                    isOptionDisabled(permission.key, role)
                                      ? { label: 'Can’t be applied to this role', placement: 'top' }
                                      : undefined
                                  }
                                />
                              )}

                              {permission.type === 'radio' && (
                                <Radio
                                  checked={isOptionRadioChecked(
                                    permission.key,
                                    permission.value,
                                    role
                                  )}
                                  disabled={loading || isOptionDisabled(permission.key, role)}
                                  size={'medium'}
                                  tooltipProps={
                                    isOptionDisabled(permission.key, role)
                                      ? { label: 'Can’t be applied to this role', placement: 'top' }
                                      : undefined
                                  }
                                  onChange={() => {
                                    if (typeof permission.value === 'undefined') return

                                    optionRadioHandler(permission.key, permission.value, role)
                                  }}
                                />
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </Scrollbar>

        <RolesPermissionsAction />
      </Box>
    </Box>
  )
})
